import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 1800,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 8, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <>
      {/* Main */}
      <main>
        {/* Hero Banner */}
        <div className="hero-slider with-floating-header with-fixed-bg">
          <div className="slider-card overlay">
            <picture className="slider-media">
              <img src="assets/img/slider/b1.jpg" width={1920} height={1000} loading="eager" alt="Hero Image" />
            </picture>
            <div className="slider-content">
              <div className="container height-100 flex items-center justify-center text-center">
                <div className="content-box section-headings">
                  <div
                    className="subheading text-20 subheading-bg"

                  >
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>welcome to Aarogya OPD</span>
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h2
                    className="heading text-[70px] fw-700 max-md:text-[40px] max-md:leading-[1.4em]"
                  >
                    Healthcare Beyond Hospitalization
                  </h2>
                  <div
                    className="text text-[20px]"
                  >
                    Save up to 50% on doctor consultations, lab tests, and medicines with Aarogya OPD’s comprehensive wellness plans.
                  </div>
                  <div className="buttons">
                    <a
                      href="/plans"
                      className="button button--secondary"
                      aria-label="hero button"
                    >
                      Explore Our Plans
                      <span className="svg-wrapper">
                        <svg
                          className="icon-20"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Brand Logo */}
        <center className="min-md:px-[200px] mt-[80px]" id="about">
          <div className="swiper h3-partner_slider mt-11 overflow-hidden">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <img src="assets/img/brand/1.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/2.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/4.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/5.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/6.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/7.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/8.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/9.png" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/10.png" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/11.png" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/12.png" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/13.svg" alt="" />
              </div>
              <div
                className="swiper-slide"
              >
                <img src="assets/img/brand/14.png" alt="" />
              </div>
            </div>
          </div>
        </center>

        {/* Image Text */}
        <div className="image-text mt-100">
          <div className="container">
            <div className="grid lg:grid-cols-2 lg:gap-1 items-center">
              <div className="lg:col-span-1 col-span-2">
                <div className="media-wrap">
                  <img
                    src="assets/img/image-text/img1.png"
                    width={992}
                    height={863}
                    loading="lazy"
                    alt="Image"
                  />
                </div>
              </div>
              <div className="lg:col-span-1 col-span-2">
                <div className="content section-headings">
                  <div
                    className="subheading text-20 subheading-bg"

                  >
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Our Company</span>
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h2 className="heading text-50">
                    The Heart of Aarogya
                  </h2>
                  <div className="text text-18">
                    Our Philosophy The word Aarogya signifies a state of being disease-free. At Aarogya OPD, we believe that healthcare should be proactive, not reactive. Our Mission To make quality primary healthcare affordable and accessible to every household. We aim to reduce the "out-of-pocket" medical inflation that affects millions of families by providing a structured, subscription-based wellness ecosystem.
                  </div>
                  <ul className="text-lists list-unstyled">
                    <li className="text-item text text-18">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={28}
                        height={28}
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_9088_5324)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.81362 13.0268C8.34112 12.7113 7.70994 12.783 7.31911 13.196C6.92886 13.6084 6.89211 14.2431 7.23336 14.6975L10.7334 19.3642C10.9445 19.6453 11.2712 19.8168 11.6229 19.8303C11.9741 19.8431 12.313 19.6972 12.5446 19.4324L20.7113 10.0991C21.1144 9.63883 21.0928 8.94525 20.6623 8.51008C20.2318 8.07492 19.5388 8.04692 19.0739 8.44475L11.5786 14.8696L8.81362 13.0268Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.9327 0.515625C6.52939 0.515625 0.519531 6.52549 0.519531 13.9288C0.519531 21.3321 6.52939 27.3419 13.9327 27.3419C21.336 27.3419 27.3458 21.3321 27.3458 13.9288C27.3458 6.52549 21.336 0.515625 13.9327 0.515625ZM13.9327 1.68166C20.6921 1.68166 26.1798 7.16938 26.1798 13.9288C26.1798 20.6882 20.6921 26.1759 13.9327 26.1759C7.17329 26.1759 1.68557 20.6882 1.68557 13.9288C1.68557 7.16938 7.17329 1.68166 13.9327 1.68166Z"
                            fill="CurrentColor"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.13872 12.5389C8.42939 12.0658 7.48265 12.1731 6.89698 12.792C6.31073 13.4115 6.25648 14.363 6.76806 15.0449L10.2681 19.7115C10.5848 20.1339 11.0748 20.3905 11.6021 20.4104C12.1295 20.4302 12.6376 20.2109 12.9852 19.8142L21.1519 10.4809C21.7562 9.78965 21.7241 8.74956 21.0784 8.0974C20.4326 7.44465 19.3926 7.40205 18.6961 7.99938L11.5356 14.1366L9.13872 12.5389ZM8.4918 13.5096L11.2562 15.3529C11.4738 15.4976 11.7608 15.4801 11.9597 15.3103L19.455 8.88547C19.6871 8.68597 20.0342 8.70055 20.2495 8.91814C20.4647 9.13514 20.4752 9.48222 20.274 9.71264L12.1073 19.046C11.9912 19.1778 11.8221 19.2513 11.6459 19.2443C11.4703 19.2379 11.307 19.1521 11.2014 19.0116L7.7014 14.3449C7.53106 14.1174 7.54913 13.8006 7.74455 13.5941C7.93938 13.3876 8.25497 13.3521 8.4918 13.5096Z"
                            fill="CurrentColor"
                          />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width={28} height={28} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Network: Partnered with 500+ clinics and diagnostic centers.
                    </li>
                    <li className="text-item text text-18">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={28}
                        height={28}
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_9088_5324)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.81362 13.0268C8.34112 12.7113 7.70994 12.783 7.31911 13.196C6.92886 13.6084 6.89211 14.2431 7.23336 14.6975L10.7334 19.3642C10.9445 19.6453 11.2712 19.8168 11.6229 19.8303C11.9741 19.8431 12.313 19.6972 12.5446 19.4324L20.7113 10.0991C21.1144 9.63883 21.0928 8.94525 20.6623 8.51008C20.2318 8.07492 19.5388 8.04692 19.0739 8.44475L11.5786 14.8696L8.81362 13.0268Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.9327 0.515625C6.52939 0.515625 0.519531 6.52549 0.519531 13.9288C0.519531 21.3321 6.52939 27.3419 13.9327 27.3419C21.336 27.3419 27.3458 21.3321 27.3458 13.9288C27.3458 6.52549 21.336 0.515625 13.9327 0.515625ZM13.9327 1.68166C20.6921 1.68166 26.1798 7.16938 26.1798 13.9288C26.1798 20.6882 20.6921 26.1759 13.9327 26.1759C7.17329 26.1759 1.68557 20.6882 1.68557 13.9288C1.68557 7.16938 7.17329 1.68166 13.9327 1.68166Z"
                            fill="CurrentColor"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.13872 12.5389C8.42939 12.0658 7.48265 12.1731 6.89698 12.792C6.31073 13.4115 6.25648 14.363 6.76806 15.0449L10.2681 19.7115C10.5848 20.1339 11.0748 20.3905 11.6021 20.4104C12.1295 20.4302 12.6376 20.2109 12.9852 19.8142L21.1519 10.4809C21.7562 9.78965 21.7241 8.74956 21.0784 8.0974C20.4326 7.44465 19.3926 7.40205 18.6961 7.99938L11.5356 14.1366L9.13872 12.5389ZM8.4918 13.5096L11.2562 15.3529C11.4738 15.4976 11.7608 15.4801 11.9597 15.3103L19.455 8.88547C19.6871 8.68597 20.0342 8.70055 20.2495 8.91814C20.4647 9.13514 20.4752 9.48222 20.274 9.71264L12.1073 19.046C11.9912 19.1778 11.8221 19.2513 11.6459 19.2443C11.4703 19.2379 11.307 19.1521 11.2014 19.0116L7.7014 14.3449C7.53106 14.1174 7.54913 13.8006 7.74455 13.5941C7.93938 13.3876 8.25497 13.3521 8.4918 13.5096Z"
                            fill="CurrentColor"
                          />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width={28} height={28} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Transparency: No hidden charges or complicated claim processes.
                    </li>
                    <li className="text-item text text-18">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={28}
                        height={28}
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_9088_5324)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.81362 13.0268C8.34112 12.7113 7.70994 12.783 7.31911 13.196C6.92886 13.6084 6.89211 14.2431 7.23336 14.6975L10.7334 19.3642C10.9445 19.6453 11.2712 19.8168 11.6229 19.8303C11.9741 19.8431 12.313 19.6972 12.5446 19.4324L20.7113 10.0991C21.1144 9.63883 21.0928 8.94525 20.6623 8.51008C20.2318 8.07492 19.5388 8.04692 19.0739 8.44475L11.5786 14.8696L8.81362 13.0268Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.9327 0.515625C6.52939 0.515625 0.519531 6.52549 0.519531 13.9288C0.519531 21.3321 6.52939 27.3419 13.9327 27.3419C21.336 27.3419 27.3458 21.3321 27.3458 13.9288C27.3458 6.52549 21.336 0.515625 13.9327 0.515625ZM13.9327 1.68166C20.6921 1.68166 26.1798 7.16938 26.1798 13.9288C26.1798 20.6882 20.6921 26.1759 13.9327 26.1759C7.17329 26.1759 1.68557 20.6882 1.68557 13.9288C1.68557 7.16938 7.17329 1.68166 13.9327 1.68166Z"
                            fill="CurrentColor"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.13872 12.5389C8.42939 12.0658 7.48265 12.1731 6.89698 12.792C6.31073 13.4115 6.25648 14.363 6.76806 15.0449L10.2681 19.7115C10.5848 20.1339 11.0748 20.3905 11.6021 20.4104C12.1295 20.4302 12.6376 20.2109 12.9852 19.8142L21.1519 10.4809C21.7562 9.78965 21.7241 8.74956 21.0784 8.0974C20.4326 7.44465 19.3926 7.40205 18.6961 7.99938L11.5356 14.1366L9.13872 12.5389ZM8.4918 13.5096L11.2562 15.3529C11.4738 15.4976 11.7608 15.4801 11.9597 15.3103L19.455 8.88547C19.6871 8.68597 20.0342 8.70055 20.2495 8.91814C20.4647 9.13514 20.4752 9.48222 20.274 9.71264L12.1073 19.046C11.9912 19.1778 11.8221 19.2513 11.6459 19.2443C11.4703 19.2379 11.307 19.1521 11.2014 19.0116L7.7014 14.3449C7.53106 14.1174 7.54913 13.8006 7.74455 13.5941C7.93938 13.3876 8.25497 13.3521 8.4918 13.5096Z"
                            fill="CurrentColor"
                          />
                        </g>
                        <defs>
                          <clipPath>
                            <rect width={28} height={28} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Support: A dedicated health manager for every member.
                    </li>
                  </ul>
                  <div className="buttons">
                    <a
                      href="/plans"
                      className="button button--primary"
                      aria-label="Explore Plans"
                    >
                      View Plans
                      <span className="svg-wrapper">
                        <svg
                          className="icon-20"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Multicolmun */}
        <div className="multicolumn multicolumn-page section-padding">
          <div className="container">
            <div className="multicolumn-header section-headings">
              <div className="subheading text-20 subheading-bg">
                <svg
                  className="icon icon-14"
                  xmlns="http://www.w3.org/2000/svg"
                  width={14}
                  height={14}
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <g clipPath="url(#clip0_9088_4143)">
                    <path
                      d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                      fill="CurrentColor"
                    />
                  </g>
                  <defs>
                    <clipPath>
                      <rect width={14} height={14} fill="CurrentColor" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Our Benefits</span>
                <svg
                  className="icon icon-14"
                  xmlns="http://www.w3.org/2000/svg"
                  width={14}
                  height={14}
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <g clipPath="url(#clip0_9088_4143)">
                    <path
                      d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                      fill="CurrentColor"
                    />
                  </g>
                  <defs>
                    <clipPath>
                      <rect width={14} height={14} fill="CurrentColor" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h2 className="heading text-50">
                Why Choose <br />Aarogya OPD?
              </h2>
            </div>
            <div className="multicolumn-inner section-content">
              <div className="grid grid-cols-12 product-grid md:gap-[20px]">
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/1.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">Savings on Daily Healthcare</h2>
                    <div className="text text-16">
                      Most health insurance policies only cover you when you are hospitalized. Aarogya OPD covers the 90% of healthcare that happens outside the hospital—saving you up to 50% on doctor consultation fees, diagnostic tests, and monthly pharmacy bills.
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/2.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">Zero Waiting Periods</h2>
                    <div className="text text-16">
                      Traditional insurance often makes you wait years for certain coverages. With Aarogya OPD, your benefits start the moment your membership is active. Whether it’s a pre-existing condition or a routine check-up, you can access your benefits from Day 1.
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/3.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">A Seamless "No-Claims" Experience</h2>
                    <div className="text text-16">
                      Say goodbye to the nightmare of filling out reimbursement forms and waiting weeks for a refund. Our plans focus on instant discounts and cashless experiences at the point of service. Just show your digital app and walk out with your savings.
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/4.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">Pan-India Network of Specialists</h2>
                    <div className="text text-16">
                      You aren't restricted to one clinic. We have partnered with an extensive network of verified General Practitioners and Specialists (Cardiologists, Pediatricians, Gynecologists, etc.), ensuring that quality healthcare is always just a few minutes away from your home.
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/5.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">360° Primary Care Ecosystem</h2>
                    <div className="text text-16">
                      We provide a one-stop solution for all your primary health needs. From doctor consultations and laboratory screenings to home delivery of medicines, our plans integrate every step of the recovery process into one single membership.
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-4 md:col-span-6 col-span-12">
                  <div className="multicolumn-card">
                    <div className="card-icon">
                      <img src="assets/img/6.svg" className="w-[40px]" alt="" />
                    </div>
                    <h2 className="heading text-28">Focus on Preventive Wellness</h2>
                    <div className="text text-16">
                      We believe in the old adage: "Prevention is better than cure." Our plans aren't just for when you're sick; they include comprehensive annual health check-ups and routine screenings designed to catch health risks early, keeping you and your family healthy and active.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="section-headings text-center">
              <div className="buttons">
                <a
                  href="/plans"
                  className="button button--primary"
                  aria-label="More Services"
                >
                  Explore Plans
                  <span className="svg-wrapper">
                    <svg
                      className="icon-20"
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                        fill="CurrentColor"
                      />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Text Banner */}
        <div className="text-banner">
          <div className="container-fluid">
            <div className="text-banner-inner radius18">
              <div className="section-headings">
                <div
                  className="subheading text-20 subheading-bg"

                >
                  <svg
                    className="icon icon-14"
                    xmlns="http://www.w3.org/2000/svg"
                    width={14}
                    height={14}
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_9088_4143)">
                      <path
                        d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                        fill="CurrentColor"
                      />
                    </g>
                    <defs>
                      <clipPath>
                        <rect width={14} height={14} fill="CurrentColor" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>Immediate Care</span>
                  <svg
                    className="icon icon-14"
                    xmlns="http://www.w3.org/2000/svg"
                    width={14}
                    height={14}
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_9088_4143)">
                      <path
                        d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                        fill="CurrentColor"
                      />
                    </g>
                    <defs>
                      <clipPath>
                        <rect width={14} height={14} fill="CurrentColor" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h2 className="heading text-80 leading-[1.3em]">
                  Instant access. Zero waiting. Day 1 benefits.
                </h2>
                <p className="text !max-w-[80%] text-24 leading-[1.4em]">
                  Healthcare That Doesn’t Make You Wait. No waiting periods. No complicated claim forms. Just instant access to top-rated doctors and diagnostic labs the moment you sign up. Your journey to wellness begins here.
                </p>
                <div className="buttons">
                  <a
                    href="/contact"
                    className="button button--secondary"
                    aria-label="See More Services"
                  >
                    Learn More
                    <span className="svg-wrapper">
                      <svg
                        className="icon-20"
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                          fill="CurrentColor"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Text Image */}
        <div className="text-image-sticky mt-100">
          <div className="container">
            <div className="section-headings section-headings-horizontal align-items-start overflow-hidden">
              <div className="section-headings-left">
                <h2 className="heading text-50">
                  Your Path to <br className="max-md:hidden" />Hassle-Free Health
                </h2>
              </div>
              <div
                className="section-headings-right text text-18"

              >
                Get started in 3 simple steps <br className="max-md:hidden" />— no paperwork, no delays.
              </div>
            </div>
            <div className="section-content">
              <div className="image-text-card radius18">
                <div className="grid grid-cols-2 gap-[40px] items-center product-grid">
                  <div className="lg:col-span-1 col-span-2">
                    <div className="content section-headings">
                      <div
                        className="subheading text-20 subheading-bg"

                      >
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span>Step 1</span>
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h2 className="heading text-50">
                        Choose Your Plan
                      </h2>
                      <div className="text text-18">
                        Select the wellness plan that best fits your needs—whether it’s for yourself, your parents, or your entire family.
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1 col-span-2">
                    <div className="media-wrap radius18">
                      <img
                        src="assets/img/project/1.svg"
                        width={1000}
                        height={707}
                        loading="lazy"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="image-text-card radius18">
                <div className="grid grid-cols-2 gap-[40px] items-center product-grid">
                  <div className="lg:col-span-1 col-span-2">
                    <div className="content section-headings">
                      <div
                        className="subheading text-20 subheading-bg"

                      >
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span>Step 2</span>
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h2 className="heading text-50">
                        Instant Activation
                      </h2>
                      <div className="text text-18">
                        Complete your registration and receive your plan activation immediately via phone and Email. Your benefits start the second you join.
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1 col-span-2">
                    <div className="media-wrap radius18">
                      <img
                        src="assets/img/project/2.svg"
                        width={1000}
                        height={707}
                        loading="lazy"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="image-text-card radius18">
                <div className="grid grid-cols-2 gap-[40px] items-center product-grid">
                  <div className="lg:col-span-1 col-span-2">
                    <div className="content section-headings">
                      <div
                        className="subheading text-20 subheading-bg"

                      >
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span>Step 3</span>
                        <svg
                          className="icon icon-14"
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_9088_4143)">
                            <path
                              d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                              fill="CurrentColor"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width={14} height={14} fill="CurrentColor" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h2 className="heading text-50">
                        Book with Ease
                      </h2>
                      <div className="text text-18">
                        Use our portal or app to find a partner doctor, lab, or pharmacy near you and book your appointment in just a few clicks.
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1 col-span-2">
                    <div className="media-wrap radius18">
                      <img
                        src="assets/img/project/3.svg"
                        width={1000}
                        height={707}
                        loading="lazy"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <div className="testimonial mt-100 section-padding">
          <div className="container">
            <div className="grid grid-cols-12 lg:grid-gap-1">
              <div className="lg:col-span-5 col-span-12">
                <div className="section-headings section-headings-sticky">
                  <div
                    className="subheading text-20 subheading-bg"
                    
                  >
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Testimonial</span>
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h2 className="heading text-50" >
                    See what our customers have to say about us
                  </h2>
                </div>
              </div>
              <div className="lg:col-span-7 col-span-12">
                <div className="testimonial-card-inner">
                  <div
                    className="card-testimonial radius18"
                  >
                    <ul className="rating-list list-unstyled">
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                    </ul>
                    <p className="text text-24">
                      “ Finally, a plan that works instantly! I’ve always hated the paperwork involved with traditional insurance. With Aarogya OPD, I signed up in the morning and used my digital app for a specialist consultation the same afternoon. No claims, no waiting—just instant savings. ”
                    </p>
                    <div className="user-info-wrap">
                      <div className="user-info">
                        <div className="user-img">
                          <img
                            src="assets/img/testimonial/1.jpg"
                            width={80}
                            height={80}
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="user-name-desig">
                          <h2 className="user-name heading text-24">Ankit Sharma</h2>
                          <div className="user-desig text text-18">
                            Mumbai
                          </div>
                        </div>
                      </div>
                      <div className="icon-quote">
                        <svg
                          className="icon icon-62"
                          width={62}
                          height={62}
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-testimonial radius18"
                  >
                    <ul className="rating-list list-unstyled">
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                    </ul>
                    <p className="text text-24">
                      “ A lifesaver for parents. With two young kids, we are at the pediatrician’s office almost every month. Aarogya OPD has helped us save over ₹12,000 this year on consultation fees and lab tests alone. It’s the best investment I’ve made for my family’s health ”
                    </p>
                    <div className="user-info-wrap">
                      <div className="user-info">
                        <div className="user-img">
                          <img
                            src="assets/img/testimonial/2.jpg"
                            width={80}
                            height={80}
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="user-name-desig">
                          <h2 className="user-name heading text-24">
                            Meera Vasudevan
                          </h2>
                          <div className="user-desig text text-18">
                            Lucknow
                          </div>
                        </div>
                      </div>
                      <div className="icon-quote">
                        <svg
                          className="icon icon-62"
                          width={62}
                          height={62}
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-testimonial radius18"
                  >
                    <ul className="rating-list list-unstyled">
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                      <li className="rating-icon">
                        <svg
                          className="icon icon-24"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </li>
                    </ul>
                    <p className="text text-24">
                      “ Peace of mind for my monthly expenses. My blood sugar tests and monthly medicines used to be a huge financial burden. Now, thanks to the Aarogya Premium Plan, I get my tests done at half the price and my medicines delivered with a great discount. It’s truly made healthcare affordable for me. ”
                    </p>
                    <div className="user-info-wrap">
                      <div className="user-info">
                        <div className="user-img">
                          <img
                            src="assets/img/testimonial/3.jpg"
                            width={80}
                            height={80}
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="user-name-desig">
                          <h2 className="user-name heading text-24">Rajesh Gupta</h2>
                          <div className="user-desig text text-18">
                            Delhi
                          </div>
                        </div>
                      </div>
                      <div className="icon-quote">
                        <svg
                          className="icon icon-62"
                          width={62}
                          height={62}
                          viewBox="0 0 62 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.5312 9.41406C6.51702 9.41406 0 15.9329 0 23.9453C0 31.2606 5.43154 37.3306 12.4771 38.3311C11.9131 42.4287 10.3486 46.3275 7.90415 49.7085C7.42874 50.3683 7.44654 51.2624 7.9538 51.9009C8.4515 52.5292 9.31635 52.7674 10.0754 52.4473C21.6088 47.6332 29.0625 36.4438 29.0625 23.9453C29.0625 15.9329 22.5455 9.41406 14.5312 9.41406ZM47.4688 9.41406C39.4545 9.41406 32.9375 15.9329 32.9375 23.9453C32.9375 31.2606 38.369 37.3306 45.4146 38.3311C44.8506 42.4287 43.2861 46.3275 40.8417 49.7085C40.3662 50.3683 40.384 51.2624 40.8913 51.9009C41.389 52.5292 42.2538 52.7674 43.0129 52.4473C54.5463 47.6332 62 36.4438 62 23.9453C62 15.9329 55.483 9.41406 47.4688 9.41406Z"
                            fill="CurrentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default HomePage;
